/**
 * Public Program Schedule editor — opened from the tokenized link at the bottom
 * of the monthly Program Schedule email. No login: the unguessable token in the
 * URL scopes the page to ONE org + sport task list (routes/comm.py /public/*).
 * Doc: docs/PROGRAM_SCHEDULE.md.
 */
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { TaskTable } from '../components/ProgramSchedulePanel';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/comm/public`;

export default function ProgramScheduleEditPage() {
  const { token } = useParams();
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API}/${token}`).then((r) => setMeta(r.data))
      .catch((e) => setError(e.response?.data?.detail || 'This link is not valid'));
  }, [token]);

  const api = useMemo(() => ({
    list: async () => (await axios.get(`${API}/${token}`)).data.tasks,
    create: (b) => axios.post(`${API}/${token}/tasks`, b),
    update: (id, b) => axios.patch(`${API}/${token}/tasks/${id}`, b),
    remove: (id) => axios.delete(`${API}/${token}/tasks/${id}`),
  }), [token]);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 px-4 py-6">
      <div className="max-w-5xl mx-auto space-y-3">
        {error ? <p className="text-sm text-red-600">{error}</p> : !meta ? <p className="text-sm text-slate-500">Loading…</p> : (
          <>
            <h1 className="text-lg font-bold">{meta.org_name} — {meta.sport_title} Program Schedule</h1>
            <p className="text-xs text-slate-500">Add, edit or delete activities. Changes save as you leave each cell.</p>
            <TaskTable api={api} />
          </>
        )}
      </div>
    </div>
  );
}
